<style src="css/appraiseList.css" scoped></style>
<template>
    <div style="padding-top: 1rem">
        <!--        <div class="topbar-wrapper">-->
        <!--            <div class="topbar">-->
        <!--                <span class="back" @click="back"></span>-->
        <!--                评价-->
        <!--            </div>-->
        <!--        </div>-->
        <topbar text="评价"></topbar>
        <div class="topBox">
            <div class="docInfoBox">
                <img :src="EnvUrl+doctor.doctorWorkPhoto" alt="">
                <div class="docInfo">
                    <div class="docName">{{doctor.doctorName}}</div>
                    <div class="docNum">{{count}}条评价</div>
                </div>
            </div>

            <div class="contentBox">
                <div class="contentTitle">
                    全部评价
                </div>
                <ul class="contentList">
                    <li class="contentItem" v-for="item in commentList">
                        <div class="liTop">
                            <div class="img"></div>
                            <div class="infoBox">
                                <div class="userNameBox">
                                    <div class="userName">匿名</div>
                                </div>
                                <ul class="flower">
                                    <li v-for="(v,i) in 5" :class="{active:item.star>i}"></li>
                                </ul>
<!--                                <div class="infoTime">{{item.createTime | time}}</div>-->
                            </div>
                        </div>
                        <div class="word">{{item.content}}</div>
                        <ul class="tabList">
                            <li v-for="v in JSON.parse(item.tag)">{{v}}</li>
                        </ul>
                    </li>
                    <!--<li class="contentItem">-->
                    <!--<div class="liTop">-->
                    <!--<img src="" alt="">-->
                    <!--<div class="infoBox">-->
                    <!--<div class="userNameBox">-->
                    <!--<div class="userName">匿名</div>-->
                    <!--<ul class="flower">-->
                    <!--<li></li>-->
                    <!--<li></li>-->
                    <!--<li></li>-->
                    <!--</ul>-->
                    <!--</div>-->
                    <!--<div class="infoTime">2020-03-28</div>-->
                    <!--</div>-->
                    <!--</div>-->
                    <!--<div class="word">老师很棒，看到了自己的一些自己的一些心理模式，期待下次咨询自己的一些心理模式，期待下次咨询心理模式，期待下次咨询。</div>-->
                    <!--<ul class="tabList">-->
                    <!--<li>很专业</li>-->
                    <!--<li>很专业很专业</li>-->
                    <!--<li>很专业很专业</li>-->
                    <!--<li>很专业很专业</li>-->
                    <!--<li>很专业</li>-->
                    <!--</ul>-->
                    <!--</li>-->
                    <no-more-data :noMoreData="noMoreData"></no-more-data>
                </ul>
            </div>
        </div>


    </div>
</template>
<script>
    import {getSource, getSources} from "../api"

    import noMoreData from 'components/no-more-data'
    import topbar from 'components/topbar'
    import moment from 'moment/moment'

    import {Swiper, Slide} from 'vue-swiper-component';

    export default {
        data() {
            return {
//                EnvUrl: `https://oml9ntix5.qnssl.com/`, // 七牛图片
                EnvUrl: `https://cdn.ysqingxin.com/`,
                commentList: [],
                pageIndex: 1,
                pageSize: 10,
                noMoreData: false,
                isLoading: false,
                emptyStatus: false,
                count: 0,
                doctor: {
                    doctorWorkPhoto: ''
                },
            }
        },
        components: {
            noMoreData,
            topbar,
            Swiper,
            Slide,
        },
        filters: {
            time(value) {
                let transTime = moment(value).format('YYYY-MM-DD HH:mm:ss')
                return transTime
            },
            isPayStatus(value) {
                return ['', '已支付'][value]
            }
        },
        computed: {},
        methods: {
            back() {
                history.back()
            },

            handleScroll() {
//                console.log(11)
                let scrolltop = document.documentElement.scrollTop || document.body.scrollTop;
                let bottomOfWindow = document.documentElement.offsetHeight - scrolltop - window.innerHeight <= 200
                if (bottomOfWindow && this.isLoading == false) {

                    if (this.pageIndex >= Math.ceil(this.count / this.pageSize)) {
                        this.noMoreData = true
                    } else {
                        this.isLoading = true;
                        this.pageIndex = this.pageIndex + 1;
                        this.getCommentList()
                    }
                }
            },
            async getCommentList() {
                let obj = {}
                obj.pageIndex = this.pageIndex;
                obj.pageSize = this.pageSize;
                obj.doctorId = this.$route.query.doctorId;
                let data = await getSources("/bear-scale/api/chatQuestion/getCommentList.json", obj);
                if (data.status === 0) {
                    this.isLoading = false;
                    this.count = data.count;
                    this.doctor = data.doctor;
                    this.commentList = [...this.commentList, ...data.commentList];
                    if (data.commentList.length == 0) {
                        this.emptyStatus = true
                    } else {
                        if (this.pageIndex >= Math.ceil(this.count / this.pageSize)) {
                            console.log('显示')
                            this.noMoreData = true
                        } else {
                            this.noMoreData = false
                        }
                    }

                }else{
                    alert(data.msg)
                }
            },

        },
        destroyed() {
            window.removeEventListener('scroll', this.handleScroll);//监听页面滚动事件
        },
        mounted() {

            this.getCommentList();
            window.addEventListener('scroll', this.handleScroll);//监听页面滚动事件
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/appraiseList.vue?8e7e6258